/*
 * Public API Surface of plugin-device-notification
 */

export * from './lib/device-notification.service';
export * from './lib/device-notification.module';
